import { withStyles } from '@mui/styles';
import { compose } from 'recompose';
import QuestionsPage from './questions-page';
import { styles } from './questions-page.styles';

// export default compose(withStyles(styles))(QuestionsPage);
export default withStyles(styles, { withTheme: true })(QuestionsPage);
